const ProfileTypes = {
	UPDATE_PROFILE_DETAILS: {
		SUCCESS: 'UPDATE_PROFILE_DETAILS_SUCCESS',
		FAILURE: 'UPDATE_PROFILE_DETAILS_FAILURE',
		PENDING: 'UPDATE_PROFILE_DETAILS_PENDING',
	},
	GET_PROFILE_DETAILS: {
		SUCCESS: 'GET_PROFILE_DETAILS_SUCCESS',
		FAILURE: 'GET_PROFILE_DETAILS_FAILURE',
		PENDING: 'GET_PROFILE_DETAILS_PENDING',
	},
	ADD_PROFILE_DETAILS: {
		SUCCESS: 'ADD_PROFILE_DETAILS_SUCCESS',
		FAILURE: 'ADD_PROFILE_DETAILS_FAILURE',
		PENDING: 'ADD_PROFILE_DETAILS_PENDING',
	},
	ADD_ONBOARD_DETAILS: {
		SUCCESS: 'ADD_ONBOARD_SUCCESS',
		FAILURE: 'ADD_ONBOARD_FAILURE',
		PENDING: 'ADD_ONBOARD_PENDING',
	},
	SEND_MOBILE_OTP: {
		SUCCESS: 'SEND_MOBILE_OTP_SUCCESS',
		FAILURE: 'SEND_MOBILE_OTP_FAILURE',
		PENDING: 'SEND_MOBILE_OTP_PENDING',
	},
	VERIFY_MOBILE_OTP: {
		SUCCESS: 'VERIFY_MOBILE_OTP_SUCCESS',
		FAILURE: 'VERIFY_MOBILE_OTP_FAILURE',
		PENDING: 'VERIFY_MOBILE_OTP_PENDING',
	},

	SUBCRIBE_FOR_UPDATES: {
		SUCCESS: 'SUBCRIBE_FOR_UPDATES_SUCCESS',
		FAILURE: 'SUBCRIBE_FOR_UPDATES_FAILURE',
		PENDING: 'SUBCRIBE_FOR_UPDATES_PENDING',
	},
	UPDATE_COACH_STREAM: {
		SUCCESS: 'UPDATE_COACH_STREAM_SUCCESS',
		FAILURE: 'UPDATE_COACH_STREAM_FAILURE',
		PENDING: 'UPDATE_COACH_STREAM_PENDING',
	},

	CHANGE_PHONE: 'CHANGE_PHONE',
	CHANGE_EMAIL: 'CHANGE_EMAIL',
	CHANGE_FULL_NAME: 'CHANGE_FULL_NAME',
	SHOW_HIDE_USER_TYPE: 'SHOW_HIDE_USER_TYPE',
	HANDLE_INPUT_CHANGE: 'HANDLE_INPUT_CHANGE',
	RESET_PIN: 'RESET_PIN',
	RESET_STATE_VAL: 'RESET_STATE_VAL',
	HANDLE_GRADUATE_DATE_CHANGE: 'HANDLE_GRADUATE_DATE_CHANGE',
	HANDLE_DATE_CHANGE: 'HANDLE_DATE_CHANGE',
	TOGGLE_PROFILE_EDIT: 'TOGGLE_PROFILE_EDIT',
	SHOW_SUBSCRIBE: 'SHOW_SUBSCRIBE',
	SHOW_USER_MODAL: 'SHOW_USER_MODAL',
	SHOW_VERIFY_MOB: 'SHOW_VERIFY_MOB',
	CHILD_STATUS: 'CHILD_STATUS',
};

export default ProfileTypes;
